// auditpm-v7
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { format, parseISO } from 'date-fns'
import { FirmHeader, AuditPlanCard } from '../components/PublicComponents'
import { toast, failed } from '../lib/toast'

const DEFAULT_ACK_QUESTIONS = [
  { id: 'ack_arrangement', label: 'I confirm the audit date and arrangements as stated in the Audit Plan.', type: 'confirm', required: true },
  { id: 'ack_readiness', label: 'I confirm that the organisation is responsible for ensuring that all relevant personnel, documents, and records are prepared and available for the audit.', type: 'confirm', required: true },
  { id: 'ack_abortive', label: 'I acknowledge that, in accordance with the Terms & Conditions, an abortive charge of S$218 (excluding GST) will apply if the audit session is postponed without at least 7 working days’ prior notice.', type: 'confirm', required: true },
  { id: 'contact_person', label: 'Name of person acknowledging (full name)', type: 'text', required: true },
  { id: 'contact_designation', label: 'Designation', type: 'text', required: true },
  { id: 'remarks', label: 'Any remarks? (optional)', type: 'textarea', required: false },
]



function AckCertificate({ job, ack }) {
  if (!ack) return <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>Loading…</div>
  return (
    <div>
      <div style={{ background: '#fff', borderRadius: 12, padding: 'clamp(16px, 4vw, 32px)', border: '0.5px solid rgba(0,0,0,0.1)' }}>
        <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 16, textAlign: 'center' }}>Audit Plan Acknowledgement</div>
        <div style={{ background: '#f7f6f3', borderRadius: 8, padding: '12px 16px', marginBottom: 16, fontSize: 13 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '130px 1fr', gap: '4px 8px' }}>
            <span style={{ color: '#888' }}>Organisation</span><strong>{job.clients?.name}</strong>
            <span style={{ color: '#888' }}>Audit date</span><strong>{job.audit_date ? format(parseISO(job.audit_date), 'd MMM yyyy') : '—'}</strong>
            <span style={{ color: '#888' }}>Time</span><span>{job.audit_time_display || '—'}</span>
            <span style={{ color: '#888' }}>Audit site</span><span>{job.audit_site_address || '—'}</span>
          </div>
        </div>
        <div style={{ marginBottom: 16 }}>
          {DEFAULT_ACK_QUESTIONS.filter(q => q.type === 'confirm').map((q) => {
            const v = (ack.answers || {})[q.id]
            return (
              <div key={q.id} style={{ display: 'flex', gap: 12, padding: '7px 0', borderBottom: '0.5px solid rgba(0,0,0,0.06)', fontSize: 13 }}>
                <span style={{ color: v === true ? '#004a4a' : '#a32d2d', fontSize: 16, flexShrink: 0 }}>{v === true ? '✓' : '✗'}</span>
                <span>{q.label}</span>
              </div>
            )
          })}
        </div>
        <div style={{ background: '#EAF3DE', borderRadius: 8, padding: '14px 16px', fontSize: 13, border: '0.5px solid #639922' }}>
          <div style={{ fontWeight: 600, color: '#27500a', marginBottom: 10 }}>✓ Acknowledgement recorded</div>
          <div style={{ display: 'grid', gridTemplateColumns: '130px 1fr', gap: '4px 8px' }}>
            <span style={{ color: '#555' }}>Acknowledged by</span><strong>{(ack.answers || {}).contact_person || '—'}</strong>
            <span style={{ color: '#555' }}>Designation</span><strong>{(ack.answers || {}).contact_designation || '—'}</strong>
            <span style={{ color: '#555' }}>Client remarks</span><span>{(ack.answers || {}).remarks ? ack.answers.remarks : 'None'}</span>
            <span style={{ color: '#555' }}>Submitted on</span><strong>{ack.submitted_at ? new Date(ack.submitted_at).toLocaleString('en-SG', { timeZone: 'Asia/Singapore' }) : '—'}</strong>
            <span style={{ color: '#555' }}>IP address</span><strong>{ack.ip_address || '—'}</strong>
            <span style={{ color: '#555' }}>Browser</span><span style={{ fontSize: 11, wordBreak: 'break-all', color: '#555' }}>{ack.user_agent ? ack.user_agent.slice(0, 120) : '—'}</span>
          </div>
        </div>
        <div style={{ marginTop: 14, textAlign: 'center' }}>
          <button onClick={() => window.print()} style={{ padding: '8px 20px', borderRadius: 8, border: '0.5px solid rgba(0,0,0,0.2)', background: '#fff', cursor: 'pointer', fontSize: 13 }}>
            🖨️ Print / Save as PDF
          </button>
        </div>
      </div>
    </div>
  )
}


function AckField({ q, value, onChange }) {
  if (q.type === 'confirm') return (
    <div style={{ padding: '14px 16px', borderRadius: 8, background: value ? '#e0f2f2' : '#f7f6f3', border: `0.5px solid ${value ? '#006363' : 'rgba(0,0,0,0.12)'}`, marginBottom: 10, cursor: 'pointer' }} onClick={() => onChange(!value)}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <div style={{ width: 20, height: 20, borderRadius: 4, flexShrink: 0, marginTop: 1, border: `1.5px solid ${value ? '#006363' : 'rgba(0,0,0,0.25)'}`, background: value ? '#006363' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {value && <span style={{ color: '#fff', fontSize: 12, fontWeight: 700 }}>✓</span>}
        </div>
        <span style={{ fontSize: 14, lineHeight: 1.5, color: value ? '#004a4a' : '#333', fontWeight: value ? 500 : 400 }}>
          {q.label}{q.required && <span style={{ color: '#a32d2d', marginLeft: 3 }}>*</span>}
        </span>
      </div>
    </div>
  )
  if (q.type === 'textarea') return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ display: 'block', fontSize: 13, color: '#666', marginBottom: 4 }}>{q.label}</label>
      <textarea value={value || ''} onChange={e => onChange(e.target.value)} rows={3}
        style={{ width: '100%', padding: '8px 10px', border: '0.5px solid rgba(0,0,0,0.2)', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', resize: 'vertical', outline: 'none' }} />
    </div>
  )
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ display: 'block', fontSize: 13, color: '#666', marginBottom: 4 }}>{q.label}{q.required && <span style={{ color: '#a32d2d', marginLeft: 3 }}>*</span>}</label>
      <input value={value || ''} onChange={e => onChange(e.target.value)}
        style={{ width: '100%', padding: '9px 11px', border: '0.5px solid rgba(0,0,0,0.2)', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', outline: 'none' }} />
    </div>
  )
}

export default function ClientAckForm() {
  const { token } = useParams()
  const [job, setJob] = useState(null)
  const [questions, setQuestions] = useState(DEFAULT_ACK_QUESTIONS)
  const [answers, setAnswers] = useState({})
  const [submitted, setSubmitted] = useState(false)
  const [submittedAck, setSubmittedAck] = useState(null)
  const [invalid, setInvalid] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [loading, setLoading] = useState(true)
  const [alreadyDone, setAlreadyDone] = useState(false)
  const [existingAck, setExistingAck] = useState(null)

  useEffect(() => { loadForm() }, [token])

  async function loadForm() {
    // Token-scoped read via RPC (returns the job + latest ack)
    const { data: found, error } = await supabase.rpc('get_job_by_ack_token', { p_token: token })
    if (error || !found || !found.id) { setInvalid(true); setLoading(false); return }
    setJob(found)
    // Same signature logic as JobDetail: a prior acknowledgement is only valid (read-only certificate)
    // while it still matches the CURRENT plan. If the plan changed since, fall through to the form so
    // the client can re-acknowledge. Reverting the plan restores the match and the certificate.
    const ackValid = !!(found.ack && found.ack_signature && found.plan_signature
      && found.ack_signature === found.plan_signature)
    if (ackValid) { setAlreadyDone(true); setExistingAck(found.ack) }
    const { data: tmpl } = await supabase.from('ack_templates')
      .select('*').eq('audit_type', found.audit_type).maybeSingle()
    setQuestions(tmpl?.questions || DEFAULT_ACK_QUESTIONS)
    setLoading(false)
  }

  function set(id, val) { setAnswers(a => ({ ...a, [id]: val })) }

  function allRequired() {
    return questions.filter(q => q.required).every(q => {
      if (q.type === 'confirm') return answers[q.id] === true
      return answers[q.id] && String(answers[q.id]).trim()
    })
  }

  async function submit() {
    if (!allRequired()) { toast('Please complete the highlighted fields', 'warning'); return }
    setSubmitting(true)
    const submittedAt = new Date().toISOString()
    let ipAddress = 'unknown'
    try { const r = await fetch('https://api.ipify.org?format=json'); ipAddress = (await r.json()).ip } catch(e) {}
    const userAgent = navigator.userAgent
    const { error: ackError } = await supabase.rpc('submit_client_ack', {
      p_token: token, p_answers: answers, p_ip: ipAddress, p_ua: userAgent,
    })
    if (ackError) { failed("We couldn't submit your acknowledgement", ackError.message, 'Please try again'); setSubmitting(false); return }
    setSubmittedAck({ answers, submitted_at: submittedAt, ip_address: ipAddress, user_agent: userAgent })
    setSubmitted(true)
    setSubmitting(false)
  }

  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f6f3' }}><div style={{ color: '#999' }}>Loading…</div></div>
  if (invalid) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f6f3', padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 32, maxWidth: 440, textAlign: 'center', border: '0.5px solid rgba(0,0,0,0.12)' }}>
        <div style={{ fontSize: 32, marginBottom: 12 }}>🔗</div>
        <h2 style={{ fontWeight: 500, marginBottom: 8 }}>Invalid link</h2>
        <p style={{ color: '#666', fontSize: 14 }}>This acknowledgement link is not valid. Please contact your audit coordinator.</p>
      </div>
    </div>
  )

  // Cancelled audit — nothing to acknowledge (a database rule also refuses a submission).
  if (job?.status === 'Cancelled') return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f6f3', padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 32, maxWidth: 440, textAlign: 'center', border: '0.5px solid rgba(0,0,0,0.12)' }}>
        <div style={{ fontSize: 32, marginBottom: 12 }}>⚠️</div>
        <h2 style={{ fontWeight: 500, marginBottom: 8 }}>This audit has been cancelled</h2>
        <p style={{ color: '#666', fontSize: 14 }}>There is nothing to acknowledge. Please contact us if you have any questions.</p>
      </div>
    </div>
  )

  // Already submitted — show certificate
  if (alreadyDone && existingAck) return (
    <div style={{ minHeight: '100vh', background: '#f5fafa', padding: '40px 20px 60px' }}>
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        <FirmHeader />
        <p style={{ fontSize: 13, color: '#888', marginBottom: 16, textAlign: 'center' }}>You have already submitted your acknowledgement. Here is your certificate for reference.</p>
        <AuditPlanCard job={job} />
        <AckCertificate job={job} ack={existingAck} />
      </div>
    </div>
  )

  // Just submitted — show certificate
  if (submitted) return (
    <div style={{ minHeight: '100vh', background: '#f5fafa', padding: '40px 20px 60px' }}>
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        <FirmHeader />
        <p style={{ fontSize: 13, color: '#004a4a', marginBottom: 16, textAlign: 'center', fontWeight: 500 }}>✓ Acknowledgement submitted successfully</p>
        <AuditPlanCard job={job} />
        <AckCertificate job={job} ack={submittedAck} />
      </div>
    </div>
  )

  return (
    <div style={{ minHeight: '100vh', background: '#f5fafa', padding: '40px 20px 60px' }}>
      {/* Red warning banner — always visible until submitted */}
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 999,
        background: '#c0392b', color: '#fff',
        padding: '12px 20px', display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 13, fontWeight: 500, boxShadow: '0 -2px 12px rgba(0,0,0,0.2)',
      }}>
        ⚠ You have not submitted your acknowledgement yet — please scroll down and submit before closing this page.
      </div>
      <div style={{ maxWidth: 640, margin: '0 auto', paddingBottom: 56 }}>
        <FirmHeader />
        <div style={{ marginBottom: 20 }}>
          <h1 style={{ fontWeight: 500, fontSize: 20, marginBottom: 6 }}>Audit Plan Acknowledgement</h1>
          <p style={{ color: '#666', fontSize: 14 }}>Please review the audit plan below and complete the acknowledgement. Fields marked <span style={{ color: '#a32d2d' }}>*</span> are required.</p>
        </div>

        <AuditPlanCard job={job} />

        <div style={{ background: '#fff', borderRadius: 12, padding: '20px 24px', border: '0.5px solid rgba(0,0,0,0.12)', marginBottom: 16 }}>
          <h2 style={{ fontWeight: 500, fontSize: 15, marginBottom: 10 }}>Please confirm the following</h2>
          <div style={{ marginBottom: 14 }}>
            <button onClick={() => {
              const confirmIds = questions.filter(q => q.type === 'confirm').map(q => q.id)
              const newAnswers = { ...answers }
              confirmIds.forEach(id => { newAnswers[id] = true })
              setAnswers(newAnswers)
            }} style={{ padding: '7px 16px', borderRadius: 8, border: '1px solid #006363', background: '#fff', color: '#006363', fontWeight: 500, cursor: 'pointer', fontSize: 13, transition: 'background 0.15s, color 0.15s' }}
              onMouseEnter={e => { e.currentTarget.style.background='#006363'; e.currentTarget.style.color='#fff' }}
              onMouseLeave={e => { e.currentTarget.style.background='#fff'; e.currentTarget.style.color='#006363' }}>
              ✓ Tick all
            </button>
          </div>
          {questions.filter(q => q.type === 'confirm').map(q => (
            <AckField key={q.id} q={q} value={answers[q.id]} onChange={v => set(q.id, v)} />
          ))}
          <div style={{ marginTop: 16, paddingTop: 16, borderTop: '0.5px solid rgba(0,0,0,0.08)' }}>
            <h3 style={{ fontWeight: 500, fontSize: 14, marginBottom: 12 }}>Your details</h3>
            {questions.filter(q => q.type !== 'confirm').map(q => (
              <AckField key={q.id} q={q} value={answers[q.id]} onChange={v => set(q.id, v)} />
            ))}
          </div>
        </div>

        <button onClick={submit} disabled={!allRequired() || submitting}
          style={{ width: '100%', padding: '12px 20px', borderRadius: 10, border: 'none', background: allRequired() ? '#006363' : '#ccc', color: '#fff', fontWeight: 500, fontSize: 15, cursor: allRequired() ? 'pointer' : 'not-allowed', fontFamily: 'inherit' }}>
          {submitting ? 'Submitting…' : 'Submit acknowledgement'}
        </button>
        <p style={{ textAlign: 'center', color: '#aaa', fontSize: 12, marginTop: 16 }}>CCIS Singapore Pte Ltd · query@ccis.com.sg</p>
      </div>
    </div>
  )
}